import { Cursor, IRectangle } from '@src/js/auto-test/canvas-e2e/interface/common.interface';
import {
    DisplayObject,
    Fill,
    FillStrokeAble,
    Filter,
    Text,
    ColorFill,
    TilingImageFill,
    SvgGraphics,
} from '@tencent/alloy-renderer';

/**
 * 绘制在canvas中的组件，和统一渲染层中相应的组件对应
 */
export default class CanvasElement {
    /**
     * 对应统一渲染层组件的id。可能没有设置
     */
    public id?: string;
    /**
     * 元素在canvas中的位置和大小
     */
    public rect: IRectangle;

    /**
     * 鼠标指针样式
     */
    public cursor: Cursor | null;

    /**
     * 透明度
     */
    public alpha: number;

    /**
     * 透明度
     */
    public alphaToRender: number;

    /**
     * 是否显示
     */
    public visible: boolean;

    /**
     * 缩放比例
     */
    public scaleX: number;
    public scaleY: number;

    /**
     * 旋转角度
     */
    public angle: number;

    /**
     * 位移
     */
    public translateX: number;
    public translateY: number;

    /**
     * 填充
     */
    public fill?: Fill;

    /**
     * 边框
     */
    public stroke?: Fill;

    /**
     * 边框宽度
     */
    public strokeWidth?: number;

    /**
     * 滤镜
     */
    public filters: readonly Filter[];

    /**
     * 组件中文本
     */
    public text?: string;
    public fontSize?: number;

    /**
     * 组件中文本样式
     */
    public textStyle?: any;

    /**
     * 形状的 svg 定义文本
     */
    public svgPath?: string;

    /**
     * 动画元素填充颜色
     */
    public fillColor?: string;

    /**
     * 动画元素字体颜色
     */
    public fontColor?: string;


    public constructor(view: DisplayObject) {
        this.applyElementWithDisplayObject(view);
    }


    /**
     * 通过统一渲染层组件，给element赋值。
     * @param view 统一渲染层组件
     */
    public applyElementWithDisplayObject(view: DisplayObject): CanvasElement {
        const { x, y, width, height } = view.worldBounds;
        this.rect = { x, y, width, height };

        // eslint-disable-next-line @typescript-eslint/dot-notation,dot-notation
        this.id = view['id'];
        this.cursor = view.cursor;
        this.alpha = view.alpha;
        // @ts-ignore
        // eslint-disable-next-line no-underscore-dangle
        this.alphaToRender = view._alphaToRender;
        this.svgPath = this.applySvgPath(view);
        this.visible = view.visible;

        this.scaleX = view.scaleX;
        this.scaleY = view.scaleY;
        this.angle = view.angle;
        this.translateX = view.x;
        this.translateY = view.y;

        this.filters = view.filters;

        // @ts-ignore
        this.fillColor = view?.fillColor;
        // @ts-ignore
        this.fontColor = view?.fontColor;

        if (view instanceof Text) {
            this.text = view.content;
            this.textStyle = this.applyTextStyle(view);
        }

        if (view instanceof FillStrokeAble) {
            if (view.fill) this.fill = this.applyFill(view.fill);
            if (view.stroke) {
                this.stroke = this.applyFill(view.stroke);
                this.strokeWidth = view.strokeWidth;
            }
        }

        return this;
    }

    private applyFill(fill: Fill) {
        const value: any = { };
        value.alpha = fill.alpha;
        if (fill instanceof ColorFill) {
            value.color = fill.color;
            value.type = 'colorFill';
        } else if (fill instanceof TilingImageFill) {
            value.type = 'tilingImageFill';
        }
        return value;
    }

    private applyTextStyle(text: Text) {
        const value: any = { };
        value.fontSize = text.fontSize;
        value.fontFamily = text.fontFamily;
        value.fontStyle = text.fontStyle;
        value.fontWeight = text.fontWeight;
        return value;
    }

    private applySvgPath(view: DisplayObject): string {
        if (view instanceof SvgGraphics) {
            return view.path;
        }
        return '';
    }
}
